export default function getResource(label) {
    const resources = {
        faqs: 'FAQ',
        terms: 'Modalités Beauty Insider'
    };

    return resources[label];
}
